module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Tim Farrington\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('P', [_vm._v("Tim Farrington is the author of "), _c('I', [_vm._v("Lizzie's War")]), _vm._v(", "), _c('I', [_vm._v("The Monk Downstairs")]), _vm._v(",—a New York Times Notable Book—and "), _c('I', [_vm._v("The Monk Upstairs")]), _vm._v(", as well as the critically acclaimed novels "), _c('I', [_vm._v("The California Book of the Dead")]), _vm._v(" and "), _c('I', [_vm._v("Blues for Hannah")]), _vm._v(".")], 1)], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/8Ho5Kl/tc-custom/9780062016706.jpg?1718183145866",
      "alt": "This image is the cover for the book Lizzie's War"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Lizzie's War\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("A family epic laced with authenticity, wit and unforgettable characters. Liz O'Reilly has a husband in Vietnam, 4 kids under the age of 12 (and one on the way), and a burgeoning crush on the family priest. An unconventional love story.")]), _c('p', [_vm._v(" It's Summer 1967 and Mike O'Reilly's just shipped out to Vietnam. Liz O'Reilly is trying to keep it all together for their four kids – 6 year old Deb–Deb (who believes she is an otter), 8 year old Angus, Kathie, (who at age 9 helps to integrate the local Blue Bird troop with her best friend Temperance), and 11 year old Danny – the spitting image of Mike. While Mike is off fighting \"his\" war, Liz struggles with her own desires and yearnings – to pick up the theatre career she abandoned when Danny was born, to care for the four children she loves fiercely yet also occasionally resents, to leave the backdoor unlocked so she always has an escape route. While set during the conflict in Vietnam, Farrington's novel captures the other side of any war – that of the war at home and the careening emotions of the spouses and families left behind.")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    HarperCollins\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0